import { render, staticRenderFns } from "./embeddedActions.vue?vue&type=template&id=040b43f2&scoped=true&"
import script from "./embeddedActions.vue?vue&type=script&lang=ts&"
export * from "./embeddedActions.vue?vue&type=script&lang=ts&"
import style0 from "./embeddedActions.vue?vue&type=style&index=0&id=040b43f2&scoped=true&lang=css&"
import style1 from "./embeddedActions.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040b43f2",
  null
  
)

export default component.exports